export default "__VITE_ASSET__9b71fcbe__"